export default "__VITE_ASSET__5crY09vK__"